import { create } from 'zustand';
interface SignupState {
  username: string;
  name: string;
  setSignupData: (username: string, name: string) => void;
}

export const useSignupStore = create<SignupState>((set) => ({
  username: '',
  name: '',
  setSignupData: (username: string, name: string) => set({ username, name })
}));
